module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "on-click": _vm.setTheme
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('Icon', {
    style: ({
      marginTop: '-2px',
      verticalAlign: 'middle'
    }),
    attrs: {
      "color": "#495060",
      "size": 18,
      "type": "paintbucket"
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.themeList), function(item, index) {
    return _c('DropdownItem', {
      key: index,
      attrs: {
        "name": item.name
      }
    }, [_c('Row', {
      attrs: {
        "type": "flex",
        "justify": "center",
        "align": "middle"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_c('Icon', {
      attrs: {
        "size": 20,
        "type": item.name.substr(0, 1) !== 'b' ? 'happy-outline' : 'happy',
        "color": item.menu
      }
    })], 1), _vm._v(" "), _c('span', [_c('Icon', {
      attrs: {
        "size": 22,
        "type": "record",
        "color": item.element
      }
    })], 1)])], 1)
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7b2e2b99", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b2e2b99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/views/main_components/themeDropdownMenu.vue
// module id = 1369
// module chunks = 61